var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.25a.75.75 0 01.743.648L3.75 3v14.685h15.889a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743l-.102.007H3a.75.75 0 01-.743-.648l-.007-.102V3A.75.75 0 013 2.25zm16.366 2.743l.06.019c.056.02.108.048.157.08.17.112.296.293.326.52l.006.104v2.653a.75.75 0 01-1.493.101l-.007-.101v-.844l-5.35 5.352a.75.75 0 01-.92.11l-.093-.067-2.315-1.951-3.52 3.523a.75.75 0 01-.977.073l-.084-.073a.75.75 0 01-.073-.977l.073-.084 4.008-4.009a.75.75 0 01.92-.11l.094.067 2.314 1.95 4.863-4.864h-.809a.75.75 0 01-.101-1.493l.101-.007h2.609a.76.76 0 01.21.028z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.74ea0cf5.svg";
export { ForwardRef as ReactComponent };